export default [
  {
    title: 'Administração',
    i18n: 'Admin',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Clientes',
        icon: 'UsersIcon',
        children: [
          {
            title: 'Clientes',
            i18n: 'Clients',
            route: 'admin-user-client',
          },
          {
            title: 'Clientes Deletados',
            i18n: 'Deleted_Clients',
            route: 'admin-deleted-client',
          },
          {
            title: 'Contatos',
            i18n: 'Contact',
            route: 'admin-contact',
          },
        ],
      },
      {
        title: 'Comunicação',
        icon: 'SendIcon',
        children: [
          {
            title: 'E-mail',
            i18n: 'Email',
            route: 'admin-sendmail',
          },
          {
            title: 'Leads',
            i18n: 'Leads',
            route: 'admin-leads',
          },
          {
            title: 'Solicitação de demonstração',
            i18n: 'DemoRequest',
            route: 'admin-demo-request',
          },
        ],
      },
      {
        title: 'Logs',
        icon: 'ActivityIcon',
        children: [
          {
            title: 'Acessos de Clientes',
            i18n: 'ClientAccess',
            route: 'admin-client-access',
          },
          {
            title: 'Auditlog',
            i18n: 'Auditlog',
            route: 'admin-auditlog',
          },
          {
            title: 'Autenticação de Clientes',
            i18n: 'AuthToken',
            route: 'admin-auth-token',
          },
        ],
      }
    ],
  },
]
